module.exports = __webpack_public_path__ + "img/outro_img.3a486135.png";